import api from "./api"
import { RegistrarLogErro } from "./clientefiel"

export interface RespostaIzzaItem {
    id: number | null
    resposta: string
    ativo: boolean
}

export interface RespostasIzzaPayload {
    boasVindas: RespostaIzzaItem
    aceito: RespostaIzzaItem
    retiradoBalcao: RespostaIzzaItem
    saiuParaEntrega: RespostaIzzaItem
    emProducao: RespostaIzzaItem
    emProducaoRetirada: RespostaIzzaItem
    entregue: RespostaIzzaItem
    horarioFuncionamento: RespostaIzzaItem
    taxaEntrega: RespostaIzzaItem
    contato: RespostaIzzaItem
    cardapio: RespostaIzzaItem
    formaPagamento: RespostaIzzaItem
    tempoEntrega: RespostaIzzaItem
    situacaoPedidoNormal: RespostaIzzaItem
    situacaoPedidoAtrasado: RespostaIzzaItem
    cancelamento: RespostaIzzaItem
    alteracao: RespostaIzzaItem
    modoIzza: number
}

export interface ErroApi {
    retornoErro: number
    mensagem: string
}

type RespostaRaw<T> = T & { codErro?: number; mensagem?: string }

function tratamentoResponse<T>(response: { data: RespostaRaw<T> }, chamada: string): T | ErroApi {
    const { data } = response
    if (data.codErro !== undefined && data.codErro > 0) {
        return { retornoErro: data.codErro, mensagem: data.mensagem ?? "" }
    }
    if (typeof data === "string" && data !== "") {
        return {
            retornoErro: 1,
            mensagem: `${chamada} - Erro inesperado, entre em contato com os responsáveis.`,
        }
    }
    return data
}

function erroParaRespostaRaw(error: unknown): RespostaRaw<never> {
    const axiosError = error as { message?: string; response?: { data?: unknown } }
    const data = axiosError.response?.data
    if (
        typeof data === "object" &&
        data !== null &&
        "codErro" in data &&
        (data as { codErro: number }).codErro > 0
    ) {
        const d = data as { codErro: number; mensagem?: string }
        return { codErro: d.codErro, mensagem: d.mensagem } as RespostaRaw<never>
    }
    if (axiosError.message === "Network Error") {
        return { codErro: 1, mensagem: "Verifique sua conexão!" } as RespostaRaw<never>
    }
    return { codErro: 1, mensagem: axiosError.message || "Erro desconhecido" } as RespostaRaw<never>
}

export const obterRespostasIzza = async function (
    authorization: string
): Promise<RespostasIzzaPayload | ErroApi> {
    try {
        const response = await api
            .get<RespostaRaw<RespostasIzzaPayload>>("respostaIzza/ObterRespostasIzza", {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<RespostasIzzaPayload>(response, "ObterRespostasIzza")
    } catch (error) {
        RegistrarLogErro(error, "ObterRespostasIzza", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}

export const salvarRespostasIzza = async function (
    authorization: string,
    payload: Omit<RespostasIzzaPayload, "modoIzza">
): Promise<string | ErroApi> {
    try {
        const response = await api
            .post<RespostaRaw<string>>("respostaIzza/SalvarRespostasIzza", payload, {
                headers: { "Content-Type": "application/json", Authorization: authorization },
            })
            .catch(function (error) {
                return { data: erroParaRespostaRaw(error) }
            })

        return tratamentoResponse<string>(response, "SalvarRespostasIzza")
    } catch (error) {
        RegistrarLogErro(error, "SalvarRespostasIzza", "")
        return { retornoErro: 1, mensagem: (error as Error).message }
    }
}
